import React, { useEffect, useState } from 'react';
import { Post, TitlesList, PageHead } from '../../Components';
import './IndexPage.css';
import LoadingPage from '../LoadingPage/LoadingPage';
import { useTranslation } from 'react-i18next';
import { FiList, FiX } from 'react-icons/fi'; // استيراد أيقونات فخمة للقائمة والارتداد

function IndexPage() {
  const { t } = useTranslation();
  const apiUrl = 'https://www.albarede.com/server';
    // const apiUrl = 'http://localhost/server/testServer';
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  // [حالة جديدة] للتحكم بظهور قائمة العناوين على الموبايل
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    fetch(`${apiUrl}/post.php`, {
      method: 'GET',
      mode: 'cors'
    })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then(posts => {
        const sortedPosts = posts.sort((a, b) => new Date(b.createAt) - new Date(a.createAt));
        setPosts(sortedPosts);
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error fetching posts:', error);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return <LoadingPage />;
  }

  return (
    <div className="premium-blog-page">
      <PageHead 
        title='مقالات قانونية'
        summary='تحليل التشريعات، دراسة النواحي القانونية، وتفسير المبادئ القضائية التي تهم أعمالكم.'
        disc={t('fieldsDisc')}
        btn={t('ourTeam')}
        hrefBtn='/team'
      />
      
      <div className='blog-layout-wrapper'>
        <div className='blog-grid-container'>
          
          {/* الجانب الأيمن: مجرى المقالات الأساسي (أصبح شبكة ثنائية بالـ CSS) */}
          <main className='posts-main-stream'>
            {posts.length > 0 ? (
              posts.map(post => (
                <Post 
                  key={post.id} 
                  id={post.id}  
                  title={post.title} 
                  files={post.files} 
                  summary={post.summary} 
                  author={post.author} 
                  createAt={post.createAt}
                />
              ))
            ) : (
              <p className="no-posts-message">لا توجد مقالات منشورة حالياً.</p>
            )}
          </main>
          
          {/* الجانب الأيسر: القائمة الجانبية الثابتة / والمنبثقة الذكية على الموبايل */}
          <aside className={`articles-sidebar-zone ${isSidebarOpen ? 'mobile-open' : ''}`}>
            {/* خلفية معتمة تظهر خلف القائمة على الموبايل فقط عند الفتح لإغلاقها بالضغط عليها */}
            <div className="sidebar-backdrop" onClick={() => setIsSidebarOpen(false)}></div>
            
            <div className='sticky-sidebar-card-luxury'>
              <div className="sidebar-header-wrap">
                <h2 className='sidebar-widget-title'>{t('choseAnArticles', 'عناوين المقالات')}</h2>
                {/* زر إغلاق القائمة للموبايل فقط */}
                <button className="close-sidebar-btn" onClick={() => setIsSidebarOpen(false)}>
                  <FiX />
                </button>
              </div>
              
              <div className='articles-titles-scroll-box'>
                <ul>
                  {posts.length > 0 && posts.map(post => (
                    <li key={post.id} onClick={() => setIsSidebarOpen(false)}>
                      <TitlesList id={post.id} title={post.title}/>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </aside>

        </div>
      </div>

      {/* [زر الموبايل العائم الفخم] يظهر فقط على الشاشات الصغيرة لفتح قائمة العناوين */}
      <button className="floating-sidebar-trigger-btn" onClick={() => setIsSidebarOpen(true)}>
        <FiList />
        <span>فهرس المقالات</span>
      </button>
    </div>
  );
}

export default IndexPage;